import { StratifyDocument } from "@stratify/shared";
import { EventChannel, eventChannel } from "redux-saga";
import {
  call,
  CallEffect,
  put,
  PutEffect,
  SelectEffect,
  take,
  TakeEffect,
} from "redux-saga/effects";
import { auth } from "../../../config/firebase";
import { subscribeToDocuments } from "../api/documentsApi";
import { fetchDocumentsError, fetchDocumentsSuccess } from "./documentsSlice";

interface FirestoreChannelPayload {
  documents?: StratifyDocument[];
  error?: Error;
}

function createFirestoreChannel(
  userId: string
): EventChannel<FirestoreChannelPayload> {
  return eventChannel((emit) => {
    const unsubscribe = subscribeToDocuments(
      userId,
      (documents) => emit({ documents }),
      (error) => emit({ error })
    );

    // Return unsubscribe function
    return unsubscribe;
  });
}

export function* handleSubscriptionTask(): Generator<
  CallEffect | PutEffect | SelectEffect | TakeEffect,
  void,
  any
> {
  console.log("handleSubscriptionTask started");
  if (!auth.currentUser) {
    yield put(fetchDocumentsError("User not authenticated"));
    return;
  }

  const channel = yield call(createFirestoreChannel, auth.currentUser.uid);

  try {
    while (true) {
      const { documents, error } = yield take(channel);

      if (error) {
        yield put(fetchDocumentsError(error.message));
        return;
      }

      yield put(fetchDocumentsSuccess(documents));
    }
  } finally {
    channel.close();
  }
}
